<template>
    <v-form v-model="is_valid"
            :disabled="loading">
        <v-container class="base container-fluid">
            <h1>Gerar códigos de recuperação</h1>
            <v-row>
                <v-col>
                    <p>
                        Gerar novos códigos de recuperação não redefine as chaves usadas por
                        seu aplicativo de autenticação. Esses códigos são apenas para acesso
                        de emergência em caso de perda do seu dispositivo ou do aplicativo
                        usado para autenticar.
                    </p>
                    <p>
                        Para gerar nova chave de autenticação você deve
                        <router-link to="./reset-2fa">
                            reinicializar o acesso via aplicativo
                        </router-link> e após isso
                        <router-link to="./enable-2fa">
                            recadastrar o seu dispositivo
                        </router-link>.
                    </p>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-btn @click="generate">Gerar códigos de recuperação</v-btn>
                </v-col>
            </v-row>
            <v-row v-if="!!message"
                   class="message-panel">{{ message }}</v-row>
            <ViewRecoveryCodes :data="codes"
                            v-if="viewCodes"
                            @close="closeCodes"></ViewRecoveryCodes>
        </v-container>
    </v-form>
</template>

<style lang="css">
</style>

<style lang="css" scoped>
</style>

<script lang="js">
import api from '@/services/AdminService';
import ViewRecoveryCodes from './components/ViewRecoveryCodes.vue';

export default          {
    data                () {
        return          {
            api,
            is_valid    : false,
            loading     : false,
            viewCodes   : false,

            message     : '',
            code_count  : 0,
            codes       : []
        }
    },
    components          : { ViewRecoveryCodes },
    methods             : {
        async generate  () {
            try {
                this.codes.length = 0;
                this.loading = true;
                const resp = await this.api.mfaCreateRecoveryCodes();
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha não identificada ao gerar códigos');
                    return;
                }
                this.codes.push(resp.content);
                this.code_count = this.codes.length;
                this.viewCodes  = this.code_count > 0;
                this.message    = resp.message;
            } finally {
                this.loading = false;
            }
        },
        closeCodes      () {
            this.viewCodes = false;
            this.$router.push({ name: "TwoFactorAuthentication" });
        }
    }
}
</script>